<script>
    import { onMount } from 'svelte';
    import { link } from 'svelte-spa-router';
    import StudentName from './StudentNameComponent.svelte'
    import ClassName from './ClassNameComponent.svelte';
    import TeacherName from './TeacherNameComponent.svelte';
    import TimeShower from './TimeShowerComponent.svelte';
    import ButtonToJoinClass from './ButtonToJoinClassComponent.svelte';
    import FilterButtons from './FilterButtonsForReschRequestsComponent.svelte';
    import ButtonToComment from './ButtonToLeaveCommentComponent.svelte';
    import RescheduleButton from './ButtonToRescheduleComponent.svelte';
    import StudentNameComponent from './StudentNameComponent.svelte';
    import { getApiBase } from './apiBase.js';
    
    const apiBase = getApiBase();
    
    let events = [];
    let currentFilter = 'all';
    let isUserTeacher = false;
    

    function getClassForEvent(event) {
        // Check for responsibility incidents first - apply red border
        if (event.has_responsibility_incident) {
            return 'red-border responsibility-incident';
        }
        // Determine the border color based on the logic provided
        if (event.status === 'Accepted') {
            return 'green-border';
        }
        if (event.status === 'Denied'){
            return 'red-border';
        }
        if ((event.directedTo === 'Teacher' && isUserTeacher) || (event.directedTo === 'Student' && !isUserTeacher)) {
            return 'yellow-border';
        }
        if ((event.directedTo === 'Teacher' && !isUserTeacher) || (event.directedTo === 'Student' && isUserTeacher)) {
            return 'grey-border';
        }
            return ''; // Default case, if needed
    }

    function getHeaderText(event) {
        if (event.cancelled_payable) return isUserTeacher ? 'ATŠAUKTA – APMOKAMA' : 'ATŠAUKTA NESILAIKANT ATŠAUKIMO SĄLYGŲ – APMOKAMA';
        // Check for responsibility incidents first
        if (event.has_responsibility_incident && event.incident_type === 'Atsaukimas') {
            return 'PAMOKA ATŠAUKTA TĄ PAČIA DIENĄ';
        }
        if (event.status === 'Accepted') {
            return 'PATVIRTINTA';
        }
        if (event.status === 'Denied') {
            return 'NEPATVIRTINTA';
        }
        if ((event.directedTo === 'Teacher' && isUserTeacher) || (event.directedTo === 'Student' && !isUserTeacher)) {
            return 'REIKIA ATSAKYTI';
        }
        if ((event.directedTo === 'Teacher' && !isUserTeacher) || (event.directedTo === 'Student' && isUserTeacher)) {
            return 'LAUKIAMA ATSAKYMO';
        }
        return ''; // Default case, if needed
    }
    // Function to change the link text when clicked
    function changeLinkText(event) {
      const link = event.target;
      link.textContent = "Reschedule request sent!";
    }
    const formatDateTime = (datetime) => {
        // Handle empty or null datetime
        if (!datetime || datetime === "") {
            return { timePart: "N/A", datePart: "N/A" };
        }
        
        let parts = datetime.split(" ");
        let datePart = parts[0] || "N/A";
        let timePart = parts[1] || "N/A";
        console.log(parts)
        console.log(datePart)
        console.log(timePart)
        
        return { timePart, datePart };
    };
    function isPastEvent(eventTime) {
      const eventDateTime = new Date(eventTime);
      const currentDateTime = new Date();
      return eventDateTime < currentDateTime;
    }
    
    // Function to handle confirm/deny button click
  const handleAction = async (event, action) => {
    const token = localStorage.getItem('jwtToken');

    try {
      const response = await fetch(`${apiBase}/teacher_playground/rescheduleReq/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          request_id: event.idGcal,
          action: action
        })
      });

      if (response.ok) {
        // Refresh the events after action is performed
        fetchEvents();
      } else {
        console.error('Failed to perform action:', response.statusText);
      }
    } catch (error) {
      console.error('Error in action:', error);
    }
  };

    const fetchEvents = async () => {
      const token = localStorage.getItem('jwtToken'); // Retrieve token from localStorage
  
      if (!token) {
        console.error('No JWT token found. User might not be logged in.');
        return;
      }
  
      try {
        // Determine the URL
        const url = `${apiBase}/teacher_playground/rescheduleReq/?filter=${currentFilter}`;
  
        console.log("Fetching events from:", url);
  
        // Make the request
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
  
        if (response.ok) {
          const data = await response.json();
          events = data.events;
          isUserTeacher = data.isUserTeacher
          console.log("These are the mf eventicus")
          console.log(events)
          console.log(isUserTeacher)
        } else {
            if (response.status === 401) {
                // If response is 401 Unauthorized, redirect to login
                alert('Reikia prisijungti iš naujo.');
                localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                window.location.href = '#/about'; // Redirect to login page
            } else {
                // Handle other errors
                alert('Error submitting form!');
            }
        }
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
      
    };
  
    // Handle filter change event from FilterButtons component
    const handleFilterChange = (event) => {
      currentFilter = event.detail.filter; // Update the filter
      fetchEvents(); // Fetch new events based on the filter
    };
  
    // Fetch events when the component is mounted
    onMount(() => {
      fetchEvents();
    });
    function getHeaderClass(event) {
      // Check for responsibility incidents first - apply red header
      if (event.has_responsibility_incident) {
          return 'red-header';
      }
      if (event.status === 'Accepted') {
          return 'green-header';
      }
      if (event.status === 'Denied') {
          return 'red-header';
      }
      if ((event.directedTo === 'Teacher' && isUserTeacher) || (event.directedTo === 'Student' && !isUserTeacher)) {
          return 'yellow-header';
      }
      if ((event.directedTo === 'Teacher' && !isUserTeacher) || (event.directedTo === 'Student' && isUserTeacher)) {
          return 'grey-header';
      }
      return ''; // Default case, if needed
  }
  </script>
  
  <style>
    .red-border {
        border-left: 4px solid #dc2626;
        background-color: #fef2f2;
    }
    
    .responsibility-incident {
        background-color: #ffcccc;
    }

    .yellow-border {
        border-left: 4px solid #f59e0b;
        background-color: #fffbeb;
    }

    .green-border {
        border-left: 4px solid #059669;
        background-color: #f0fdf4;
    }
    
    .grey-border {
        border-left: 4px solid #6b7280;
        background-color: #f9fafb;
    }

    .header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 0 8px 0;
        font-size: 1rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;
    }

    .red-header {
        color: #dc2626;
    }

    .yellow-header {
        color: #f59e0b;
    }

    .green-header {
        color: #059669;
    }
    
    .grey-header {
        color: #6b7280;
    }

    /* Button styling */
    button {
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 16px;
        width: 100%;
        height: 44px;
        background-color: #ffffff;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 0.875rem;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: all 0.2s ease;
        outline: none;
    }

    button:hover {
        background-color: #f3f4f6;
        border-color: #9ca3af;
    }

    button:focus {
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
    }

    .confirm-button {
        background-color: #059669;
        border-color: #059669;
        color: white;
        margin-bottom: 8px;
    }

    .confirm-button:hover {
        background-color: #047857;
        border-color: #047857;
    }

    .deny-button {
        background-color: #dc2626;
        border-color: #dc2626;
        color: white;
    }

    .deny-button:hover {
        background-color: #b91c1c;
        border-color: #b91c1c;
    }

    .classcontainer {
        padding: 20px;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
        gap: 16px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        color: #374151;
    }

    .time-section {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 12px 0;
    }

    .time-item {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .time-label {
        font-size: 0.875rem;
        font-weight: 500;
        color: #6b7280;
    }
    
    .senasLaikas .time-label {
        color: #dc2626;
    }
    
    .naujasLaikas .time-label {
        color: #059669;
    }

    .addi_text {
        font-size: 0.875rem;
        color: #6b7280;
        font-style: italic;
        padding: 12px;
        background-color: #f9fafb;
        border-radius: 6px;
        border-left: 3px solid #d1d5db;
    }

    .no-events-message {
        text-align: center;
        color: #6b7280;
        font-size: 1rem;
        padding: 40px 20px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 20px 0;
        border: 1px solid #e5e7eb;
    }

    .no-events-message p {
        color: #6b7280;
        font-size: 1rem;
        margin: 0;
        font-weight: 500;
    }

    .button-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 8px;
    }
  </style>
  
  <FilterButtons 
    currentFilter={currentFilter} 
    on:filterChange={handleFilterChange} />
  
    <div class="classSection">
      {#if events.length > 0}
        {#each events as event}
          <div class="classcontainer {getClassForEvent(event)}">
            <!-- Dynamic header based on status -->
            <div class="header {getHeaderClass(event)}">
              {getHeaderText(event)}
            </div>
      
            <!-- Render the reschedule request details -->
            <div>
              <ClassName name={event.clName} />
              <StudentName student={event.studName} />
              <TeacherName teacher={event.teacher} />
              
              <div class="time-section">
                {#if event.has_responsibility_incident && event.type === 'Cancel'}
                  <!-- For responsibility incidents with cancel: only show old time -->
                  <div class='senasLaikas time-item'>
                    <span class="time-label">Senas laikas:</span>
                    <TimeShower 
                      time={formatDateTime(event.oldDisplay).timePart} 
                      date={formatDateTime(event.oldDisplay).datePart} 
                    />
                  </div>
                {:else if event.additionalClass}
                  <!-- For additional class: only show new time -->
                  <div class='naujasLaikas time-item'>
                    <span class="time-label">Naujas laikas papildomai pamokai:</span>
                    <TimeShower 
                      time={formatDateTime(event.newDisplay).timePart} 
                      date={formatDateTime(event.newDisplay).datePart} 
                    />
                  </div>
                {:else}
                  <!-- For regular reschedule: show both old and new time -->
                  <div class='senasLaikas time-item'>
                    <span class="time-label">Senas laikas:</span>
                    <TimeShower 
                      time={formatDateTime(event.oldDisplay).timePart} 
                      date={formatDateTime(event.oldDisplay).datePart} 
                    />
                  </div>
                  {#if event.newDisplay}
                  <div class='naujasLaikas time-item'>
                    <span class="time-label">Naujas laikas:</span>
                    <TimeShower 
                      time={formatDateTime(event.newDisplay).timePart} 
                      date={formatDateTime(event.newDisplay).datePart} 
                    />
                  </div>
                  {/if}
                {/if}
              </div>
            </div>
    
            <!-- Pending event logic -->
            {#if event.has_responsibility_incident && event.type === 'Cancel'}
              <!-- Responsibility incidents with cancel are already processed, no actions needed -->
            {:else if event.status === 'Pending' && getHeaderClass(event) === 'grey-header'}
              <div class="addi_text">
                Laukiama atsakymo iš pamokos dalyvių
              </div>
            {:else if event.status === 'Pending' && getHeaderClass(event) !== "grey-header"}
              <div class="button-group">
                <button class="confirm-button" on:click={() => handleAction(event, 'confirm')}>
                  Patvirtinti
                </button>
                <button class="deny-button" on:click={() => handleAction(event, 'deny')}>
                  Atmesti
                </button>
              </div>
            {:else if event.can_participate !== false}
              <RescheduleButton classId={event.idGcal} label="Pasiūlyti kitą laiką" />
            {/if}
          </div>
        {/each}
      {:else}
        <div class="no-events-message">
          <p>Nėra prašymų keisti pamokas.</p>
        </div>
      {/if}
    </div>
